(function () {
	'use strict';

	var mod = angular.module('uwAgenda.global');
	mod.directive('clipboardCopy', ['$window', 'Alert', ClipboardCopyFn]);

	// directive to copy the given content to the clipboard
	function ClipboardCopyFn($window, Alert) {
		var directive = {
			link: link,
			restrict: 'A',
			scope: {
				content: "@"
			}
		};
		return directive;

		function link(scope, element, attrs) {
			var body = angular.element($window.document.body);
			var textarea = null;

			element.bind('click', function (e) {
				try {
					textarea = angular.element('<textarea/>');
					textarea.css({
						position: 'fixed',
						opacity: '0'
					});

					textarea.val(scope.content);
					body.append(textarea);
					textarea[0].select();

					var successfull = document.execCommand('copy');
					if (!successfull) throw 'Failed to copy content to clipboard!';
				} catch (err) {
					Alert.error(err);
				}
				textarea.remove();
			});
		}
	}
})();